module.exports = __webpack_public_path__ + "media/images/application2/AppForm__label__phone-verified__span-fa3eb7eda7754173baa327389c36feaa.svg";